// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPatientLookupResultModel {
    static getAttributeTypeMap() {
        return EnrollmentPatientLookupResultModel.attributeTypeMap;
    }
}
EnrollmentPatientLookupResultModel.discriminator = undefined;
EnrollmentPatientLookupResultModel.additionalProperties = false;
EnrollmentPatientLookupResultModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "enrollments",
        "baseName": "enrollments",
        "type": "Array<EnrollmentHistoryModel>"
    },
];
//# sourceMappingURL=enrollmentPatientLookupResultModel.js.map